
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// var redirectURL = require('../redirectURL');

 
const ConsignmentActions = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        props.onCloseUploadDiv(e);
        props.onCloseRouteDiv(e);
        props.onShowRouteDiv(props.data);
    };

    return (
        <div className="map-icon-component">
			{/*<button onClick={handleClick} className="custom-btn label label-success" title="View Timeline"><i className="icofont icofont-tree-alt"></i> Timeline </button>
            &nbsp;| &nbsp;
            */}
            <button onClick={handleRouteClick} className="custom-btn label label-success" title="View Route"><i className="icofont icofont-map-pins f25"></i> </button>
       
        </div>
    );
};

export default ConsignmentActions;
